/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Select_Guide_PlaceholderInputs */



/**
* | output |
* | --- |
* | "-- Select a guide --" |
*
* @param {Knp_Lookup_Select_Guide_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_select_guide_placeholder = /** @type {((inputs?: Knp_Lookup_Select_Guide_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Select_Guide_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("-- Selectionner un guide --")
	if (locale === "de") return /** @type {LocalizedString} */ ("-- Wählen Sie einen Leitfaden --")
	if (locale === "it") return /** @type {LocalizedString} */ ("-- Seleziona una guida --")
	if (locale === "ru") return /** @type {LocalizedString} */ ("-- Выберите руководство --")
	if (locale === "es") return /** @type {LocalizedString} */ ("-- Seleccione una guía --")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("-- 选择一位导游 --")
	if (locale === "ja") return /** @type {LocalizedString} */ ("-- ガイドを選択 --")
	if (locale === "hi") return /** @type {LocalizedString} */ ("-- एक गाइड चुनें --")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("-- Selecione um guia --")
	return /** @type {LocalizedString} */ ("-- Select a guide --")
});